const EDIT_BOOKING_PATH = Object.freeze([
    {
        serviceType: 'Private Cremation & Return of Ashes',
        path: 'private'
    },
    {
        serviceType: 'Private Cremation & Return of Ashes',
        path: 'package'
    },
    {
        serviceType: 'Private Cremation & Dispersal of Ashes',
        path: 'private'
    },
    {
        serviceType: 'Private Cremation & Dispersal of Ashes',
        path: 'package'
    },
    {
        serviceType: 'Private Cremation & Dispersal of Ashes',
        path: 'referral'
    },
    {
        serviceType: 'Private Cremation & Return of Ashes',
        path: 'referral'
    },
    {
        serviceType: 'Communal Cremation - Vet',
        path: 'communal'
    },
    {
        serviceType: 'Communal Cremation - Stray / Wildlife - Vet',
        path: 'communal'
    },
    {
        serviceType: 'Products Only',
        path: 'urns-and-memorabilia'
    },
]);

export default EDIT_BOOKING_PATH;
